import { useTranslation } from 'react-i18next';

import { Badge } from '@/components/ui/badge';
import { Webhook, WebhookType } from '@/shared/types/webhook';

export const WebhookTypeBadge = ({ webhook }: { webhook: Webhook }) => {
  const { t } = useTranslation();
  const isAction = webhook.type === WebhookType.ACTION;

  const getLabel = () => {
    switch (webhook.type) {
      case WebhookType.ACTION:
        return t('webhook.types.dialog');
      case WebhookType.FIRST_MESSAGE:
        return t('webhook.types_short.first_message');
      case WebhookType.PRE_MESSAGE:
        return t('webhook.types_short.pre_message');
      case WebhookType.POST_MESSAGE:
        return t('webhook.types_short.post_message');
      case WebhookType.LOG_MESSAGE:
        return t('webhook.types_short.log_message');
      case WebhookType.PRE_NBA:
        return t('webhook.types_short.pre_nba');
      case WebhookType.AUTH_VALIDATION:
        return t('webhook.types_short.auth_validation');
      case WebhookType.AUTH_PRE_ENTER:
        return t('webhook.types_short.auth_pre_enter');
    }
  };

  return (
    <Badge type="secondary" flavour={isAction ? 'neutral' : 'informational'} rounded={false}>
      {getLabel()}
    </Badge>
  );
};
